import { Space, TagMap } from "../types";

export const filterSpaces = (
  spaces: Space[],
  tags: TagMap,
  search: string | null | undefined
) => {
  let filteredSpaces: Space[] = spaces;
  if (search) {
    // Filter spaces by search term
    const text = search?.toLowerCase();
    if(text.search(',') !== -1) {
      const splitTextArray = text.split(',');
      for (let splitText of splitTextArray) {
        filteredSpaces = filteredSpaces.filter(
          (space: Space) =>
            (space.name && space.name.toLowerCase().search(splitText) !== -1) ||
            (space.address && space.address.toLowerCase().search(splitText) !== -1)
        );
      }
    } else if (text.search('\\|') !== -1) {
      let filteredCache: Space[] = [];
      const splitTextArray = text.split('\|');
      for (let splitText of splitTextArray) {
        filteredCache = filteredCache.concat(
          filteredSpaces.filter(
            (space: Space) =>
              (space.name && space.name.toLowerCase().search(splitText) !== -1) ||
              (space.address && space.address.toLowerCase().search(splitText) !== -1)
          )
        );
      }
      filteredSpaces = filteredCache;
    } else {
      filteredSpaces = spaces.filter(
        (space: Space) =>
          (space.name && space.name.toLowerCase().search(text) !== -1) ||
          (space.address && space.address.toLowerCase().search(text) !== -1)
      );
    }
  }
  // Filter spaces by tags selected
  for (let id of Object.keys(tags)) {
    if (tags[id].selected) {
      filteredSpaces = filteredSpaces.filter((space: Space) => {
        if (space.tags.find((tag: string) => tag === id && space.filtered)) {
          return true;
        } else {
          return false;
        }
      });
    }
  }

  return filteredSpaces;
};
